import React from 'react';
import {Provider} from 'react-redux';
import {Stack} from '@shopify/polaris';
import store from 'sections/services-marketplace/embedded/store';
import Workflow from 'sections/services-marketplace/embedded/components/workflow';
import ErrorBanner from 'sections/services-marketplace/embedded/components/error-banner';
import ErrorBoundary from 'sections/services-marketplace/embedded/components/workflow/errorBoundary';
import {AppLayout, RequireAuth} from '../../components';
import withAuth from '../with-auth/withAuth';

import styles from './CreateJob.scss';

function CreateJob() {
  return (
    <RequireAuth>
      <Provider store={store}>
        <AppLayout flush>
          <AppLayout.Container subdued slim>
            <AppLayout.Section fill>
              <div className={styles.WorkFlowContainer}>
                <ErrorBoundary>
                  <Stack vertical spacing="extraLoose">
                    <ErrorBanner />
                    <Workflow browseContext />
                  </Stack>
                </ErrorBoundary>
              </div>
            </AppLayout.Section>
          </AppLayout.Container>
        </AppLayout>
      </Provider>
    </RequireAuth>
  );
}

export default withAuth(CreateJob);
